// =========================================================
// * Volt React Dashboard
// =========================================================

// * Product Page: https://themesberg.com/product/dashboard/volt-react
// * Copyright 2021 Themesberg (https://www.themesberg.com)
// * Official Repository: https://github.com/themesberg/volt-react-dashboard
// * License: MIT License (https://themesberg.com/licensing)

// * Designed and coded by https://themesberg.com

// =========================================================

// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. Please contact us to request a removal.

import React from 'react';
import ReactDOM from 'react-dom';
import {  
  BrowserRouter as Router, } from "react-router-dom";

// core styles
import "./scss/volt.scss";

// vendor styles
import "@fortawesome/fontawesome-free/css/all.css";
import "react-datetime/css/react-datetime.css";
import 'semantic-ui-css/semantic.min.css'
//App Styles
import "./css/app.css";
import { I18nextProvider } from "react-i18next"
import i18next from "i18next"
import App from "./App";
import ScrollToTop from "./components/ScrollToTop";
import { resources } from "./common/languages"
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

i18next.init({
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: true,
  },
  lng: localStorage.getItem("language")
    ? localStorage.getItem("language")
    : "es_DO",
  resources: resources,
})

ReactDOM.render(
  <Router>
    <ScrollToTop />
    <ToastContainer />
    <I18nextProvider i18n={i18next}>
    <App />
    </I18nextProvider>
  </Router>,
  document.getElementById("root")
);
